import React from 'react'
import { Link } from 'react-router-dom';

export default function Abouthome() {

    const backgroundImage1 = "/images/about/barbiecake-removebg-preview.png"; // Update with the correct path
  const backgroundImage2 = "/images/about/cake-removebg-preview.png"; // Update with the correct path
  const backgroundImage3 = "/images/about/cake-removebg-preview.png"; // Update with the correct path
  const backgroundImage4 = "/images/about/greencake-removebg-preview.png"; // Update with the correct path
  const backgroundImage5 = "/images/about/new-removebg-preview.png"; // Update with the correct path


  return (
<div className="relative overflow-hidden mx-5 bg-white">
      <div className="pb-80 pt-16 sm:pb-40 sm:pt-24 lg:pb-48 lg:pt-40">
        <div className="relative mx-auto max-w-7xl px-4 sm:static sm:px-6 lg:px-8">
          <div className="sm:max-w-lg">
            <div className="flex ">
              <p className="font-navname text-xl text-amber-500">about Us</p>
              <div className="border-b-4 border-amber-500 h-4 w-16 flex items-center justify-center ml-5"></div>
            </div>

            <h1 className="text-2xl font-bold font-heading tracking-tight text-gray-900 sm:text-6xl">
              welcome to sauraha Gourment{" "}
            </h1>

            <p className="mt-4 text-xl text-gray-500">
              This year, our new summer collection will shelter you from the
              harsh elements of a world that doesn't care if you live or die.
            </p>
            <div className="flex md:justify-around mt-7 ">
              <div className="flex border-l-4 border-amber-500 justify-around w-44 ">
                <div className="font-bold text-amber-500 text-5xl">04</div>
                <div className="">
                  <p>Year of</p>
                  <p className="font-bold">Experinece</p>
                </div>
              </div>
              <div className="flex border-l-4 border-amber-500 justify-around w-44 ">
                <div className="font-bold text-amber-500 text-5xl">03</div>
                <div className="">
                  <p>Popular</p>
                  <p className="font-bold">Chef</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="mt-10">
              {/* Decorative image grid */}
              <div
                aria-hidden="true"
                className="pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl"
              >
                <div className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                  <div className="flex items-center space-x-6 lg:space-x-8">
                    <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-3">
                      <div className="h-64 w-44 overflow-hidden rounded-lg sm:opacity-0 lg:opacity-100">
                        <img
                          src={backgroundImage1}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-48 overflow-hidden rounded-lg">
                        <img
                          src={backgroundImage2}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                    </div>
                    <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <img
                          src={backgroundImage3}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <img
                          src={backgroundImage4}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <img
                          src={backgroundImage5}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                    </div>
                    <div className="grid flex-shrink-0 grid-cols-1 hidden md:block gap-y-6 lg:gap-y-8">
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <img
                          src={backgroundImage3}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <img
                          src={backgroundImage4}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Link
                to=""
                className="inline-block border border-transparent bg-amber-400 px-8 py-3 text-center font-medium text-white hover:bg-indigo-700"
              >
                Buy Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>  )
}
